import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { CmxHttpClient } from '@cemex/cmx-client-layout';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { IContactPersonRequest } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person.model';
import { IContactPersonResponse } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person.model';
import { IContactPersonRolesResponse } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person-role.model';


@Injectable()
export class ContactPersonApiService {
  constructor(private http: CmxHttpClient) {
    //
  }

  public fetchReceivingPersons(
    customercode: string,
    countryCode: string,
    jobsiteCode: string,
  ): Observable<IContactPersonResponse> {
    const endpoint = 'v4/crm/mycontacts';
    let params = new HttpParams();
    params = params.set('customerCode', `${customercode}.${countryCode}`);
    params = params.set('jobsiteCode', jobsiteCode);
    return this.http.get(endpoint, { params }).pipe(
      catchError(error => {
        console.error(error);
        return throwError(endpoint + ' FAILED...');
      }),
      map(response => {
        return response as IContactPersonResponse;
      }),
    );
  }

  public fetchContactPersonRoles(countryCode: string): Observable<IContactPersonRolesResponse> {
    const endpoint = 'v3/im/contactpersonroles';
    let params = new HttpParams();
    params = params.set('countryCode', countryCode);
    params = params.set('orderBy', '');
    params = params.set('page', '');
    params = params.set('fetch', '');
    return this.http.get(endpoint, { params }).pipe(
      catchError(error => {
        console.error(error);
        return throwError(endpoint + ' FAILED...');
      }),
      map(response => {
        return response as IContactPersonRolesResponse;
      }),
    );
  }

  public postNewContact(request: IContactPersonRequest): Observable<any> {
    const endpoint = 'v4/crm/contacts/';
    return this.http.post(endpoint, request).pipe(
      catchError(error => {
        console.error(error);
        return throwError(endpoint + ' FAILED...');
      }),
      map(response => {
        return response;
      }),
    );
  }
}
